import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
//import * as Yup from "yup";

// FRONTEND VALIDATION (keep commented if needed)
/*
const validationSchema = Yup.object({
  name: Yup.string().trim().min(2).required("Color name is required"),
  hexCode: Yup.string().trim().required("Hex Code is required"),
  status: Yup.string().required().oneOf(["ACTIVE", "INACTIVE"]),
});
*/

export default function ColorForm({
  initialValues,
  onSubmit,
  loading = false,
  buttonText = "Submit",
}) {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: "",
    hexCode: "",
    status: "ACTIVE",
  });

  const [errors, setErrors] = useState({});
  const [successMessage, setSuccessMessage] = useState("");

  useEffect(() => {
    if (initialValues) {
      setFormData({
        name: initialValues.name || "",
        hexCode: initialValues.hexCode || "",
        status: initialValues.status || "ACTIVE",
      });
    }
  }, [initialValues]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setErrors({});

    

      // API CALL
      const res = await onSubmit(formData);

    

      // BACKEND VALIDATION HANDLE 
      if (res?.status === 422 || res?.success === false) {
        setErrors(res?.error || {});
        return;
      }

      setSuccessMessage(
        initialValues
          ? "Color Updated Successfully"
          : "Color Added Successfully"
      );

      // reset only for add
      if (!initialValues) {
        setFormData({
          name: "",
          hexCode: "",
          priceModifier: "",
          status: "ACTIVE",
        });
      }

      setTimeout(() => {
        setSuccessMessage("");
        navigate("/color");
      }, 1500);

    } catch (err) {
      

      const apiErrors = err?.response?.data?.error;

      if (apiErrors) {
        setErrors(apiErrors);
      }
    }
  };

  return (
    <div>

      {successMessage && (
        <div className="alert alert-success">
          {successMessage}
        </div>
      )}

      <form onSubmit={handleSubmit}>
        <div className="row g-1">

          <div className="col-md-6 h80">
            <label>Color Name<span className="error">*</span></label>
            <input
              className={`form-control ${errors.name ? "is-invalid" : ""}`}
              name="name"
              value={formData.name}
              onChange={handleChange}
            />
            {errors.name && (
              <div className="invalid-feedback">
                {errors.name}
              </div>
            )}
          </div>

          <div className="col-md-6 h80">
            <label>Hex Code<span className="error">*</span></label>
            <input
              className={`form-control ${errors.hexCode ? "is-invalid" : ""}`}
              name="hexCode"
              placeholder="#FFFFFF"
              value={formData.hexCode}
              onChange={handleChange}
            />
            {errors.hexCode && (
              <div className="invalid-feedback">
                {errors.hexCode}
              </div>
            )}
          </div>

          <div className="col-md-6 h80">
            <label>Status<span className="error">*</span></label>
            <select
              className={`form-select ${errors.status ? "is-invalid" : ""}`}
              name="status"
              value={formData.status}
              onChange={handleChange}
            >
              <option value="ACTIVE">Active</option>
              <option value="INACTIVE">Inactive</option>
            </select>

            {errors.status && (
              <div className="invalid-feedback">
                {errors.status}
              </div>
            )}
          </div>

          <div className="col-12 d-flex justify-content-end gap-2">
            <button
              type="submit"
              className="btn btn-primary"
              disabled={loading}
            >
              {loading ? "Loading..." : buttonText}
            </button>
        
<button
  type="button"
  className="btn"
  style={{ backgroundColor: "#032B4D", color: "#fff" }}
  onClick={() => navigate("/color")}
>
  Cancel
</button>
          </div>

        </div>
      </form>
    </div>
  );
}